import axiosInstance from '../components/axiosInstance';

export const getQuestionsForQuestionnaire = async (questionnaireId) => {
  try {
    const response = await axiosInstance.get(`/questionnaires/${questionnaireId}/questions/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching questions", error);
    throw error;
  }
};